import produce from 'immer';
import { combineReducers } from 'redux';
import { AssistantActionType, AssistantAction } from '../../actions/assistantActions';
import { Assistant } from '../../types/resources';

interface AssistantState {
  byId: Record<string, Assistant>;
  allIds: string[];
}

export const initialState: AssistantState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: AssistantAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AssistantActionType.LIST_ASSISTANTS:
        return {};
      case AssistantActionType.LIST_ASSISTANTS_OK: {
        action.data.forEach((assistant) => {
          draft[assistant.id] = assistant;
        });

        break;
      }
      case AssistantActionType.GET_ASSISTANT_OK: {
        draft[action.assistantId] = action.data;
        break;
      }
      case AssistantActionType.EDIT_ASSISTANT_OK: {
        draft[action.assistantId] = action.data;
        break;
      }
      case AssistantActionType.DELETE_ASSISTANT_OK: {
        delete draft[action.assistantId];
        break;
      }
      case AssistantActionType.CREATE_ASSISTANT_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: AssistantAction) => {
  switch (action.type) {
    case AssistantActionType.LIST_ASSISTANTS:
      return [];
    case AssistantActionType.LIST_ASSISTANTS_OK:
      return action.data.map((assistant) => assistant.id);
    case AssistantActionType.GET_ASSISTANT_OK:
      return state.includes(action.data.id) ? state : [...state, action.data.id];
    case AssistantActionType.DELETE_ASSISTANT_OK:
      return state.filter((id) => id !== action.assistantId);
    case AssistantActionType.CREATE_ASSISTANT_OK:
      return [...state, action.data.id];
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });
